// Licensed under Gnu Public Licence version 2
// Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

export const errorCodes = {
    errNetwork: 'ERR_NETWORK',
    savingFailure: 'SAVE_RESULTS_FAILURE',
};
const errorMessages = {
    [errorCodes.errNetwork]: {
        title: 'pages.diagnostic.SystemCompatibility.no_internet_title',
        cause: '',
        remediation: 'pages.diagnostic.SystemCompatibility.no_internet_remediation',
        retry: false
    },
    [errorCodes.savingFailure]: {
        title: 'pages.diagnostic.SaveResults.saving_failure_title',
        cause: '',
        remediation: 'pages.diagnostic.SaveResults.saving_failure_remediation',
        retry: true,
    },
};

export function getErrorPageContent(error) {
    if (typeof error === 'string') {
        return {
            title: error,
            cause: '',
            remediation: '',
            retry: true,
        };
    }

    if (errorMessages[error.code]) {
       return errorMessages[error.code];
    }

    return {
        title: error.name,
        cause: error.message,
        remediation: error.code,
        retry: false
    };
}
